import { createFileRoute, Navigate } from '@tanstack/react-router'
import { StationManagement } from '@/components/admin/StationManagement'

function StationsRoute() {
  let role = ''
  try {
    const raw = localStorage.getItem('pos_user')
    if (raw) role = (JSON.parse(raw) as { role?: string }).role ?? ''
  } catch {
    role = ''
  }
  if (role === 'admin' || role === 'manager') {
    return (
      <Navigate to="/admin/settings" search={{ section: 'kitchen' }} replace />
    )
  }
  return <StationManagement />
}

export const Route = createFileRoute('/admin/stations')({
  component: StationsRoute,
})
